import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

/**
 * Where "/" and any unknown path should land.
 *
 * Sending everyone to /login and letting the login screen bounce them onward is
 * what made the Android Back button appear to log people out: the login page
 * genuinely was in the history. Deciding here means a signed-in user never
 * touches it.
 */
export const RootRedirect = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="w-8 h-8 animate-spin text-sky-600" />
      </div>
    );
  }

  return <Navigate to={user ? '/dashboard' : '/login'} replace />;
};

export default RootRedirect;
